// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TopBarFilter-base__xzGow{display:flex;gap:var(--size-4);align-items:center;width:var(--size-full);padding:var(--size-3) var(--size-4);border-bottom:var(--size-0_25) solid var(--gray-a4)}.TopBarFilter-group__dXFFd{flex:1 1 0;min-width:var(--size-0)}.TopBarFilter-action__MsdLF{display:flex;flex-shrink:0;align-items:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "TopBarFilter-base__xzGow",
	"group": "TopBarFilter-group__dXFFd",
	"action": "TopBarFilter-action__MsdLF"
};
export default ___CSS_LOADER_EXPORT___;
